<div class="tables-wrapper">
  @if (!isInitialized) {
    <app-loader/>
  } @else {
    <mat-accordion [multi]="true">
      @for (key of productCardModalTableResourcesKeys; track $index) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <div class="title">
                {{ productCardModalTableResources[key].name }}
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="data-wrapper">
            <app-records-table-container
              [resourceParams]="productCardModalTableResources[key]"
              [isFullHeight]="false"
              [defaultFilters]="filtersValuesMap[key]"
              [defaultSort]="['id,desc']"
              [isProductCardFullHeight]="!isVisibleDesc()"
            />
          </div>
        </mat-expansion-panel>
      }
    </mat-accordion>
  }
</div>
